import {
  ENTER_VERIFICATION_MFA_CODE,
  SETUP_TOTP,
  SETUP_SMS,
  SETUP_MFA_SMS_ERROR,
  SETUP_MFA_ERROR,
  SETUP_MFA_INFO,
  UPDATE_USER_ATTR,
  REMOVE_MESSAGE,
  RESEND_SUBMIT_SMS_VERIFICATION_CODE,
  FETCH_MY_CONTACTS,
  REINVITE_USER,
  CHANGE_USER_ROLE
} from "../actions/types";
import _ from "lodash";

export default function(state = {}, action) {
  switch (action.type) {
    case SETUP_TOTP: {
      if (typeof state.code != "undefined") {
        return state;
      }
      const returnProps = { ...state, code: action.payload };

      return returnProps;
    }
    case SETUP_SMS: {
      const returnProps = _.omit({ ...state }, ["code"]);

      console.log("profile_reducer. action: ", action);
      console.log("profile_reducer. returning props: ", returnProps);
      return returnProps;
    }
    // case SETUP_MFA_SMS_ERROR: {
    //   const returnProps = _.omit({ ...state, message: { type: "error", content: action.payload } }, ["code"]);
    //
    //   console.log("profile_reducer. action: ", action);
    //   console.log("profile_reducer. returning props: ", returnProps);
    //   return returnProps;
    // }
    case ENTER_VERIFICATION_MFA_CODE: {
      const returnProps = { ...state, verificationCode: action.payload };

      console.log("profile_reducer. action: ", action);
      console.log("profile_reducer. returning props: ", returnProps);
      return returnProps;
    }
    // case SETUP_MFA_ERROR: {
    //   const returnProps = { ...state, message: { type: "error", content: action.payload });
    //
    //   console.log("profile_reducer. action: ", action);
    //   console.log("profile_reducer. returning props: ", returnProps);
    //   return returnProps;
    // }
    case SETUP_MFA_INFO: {
      const returnProps = _.omit({ ...state }, ["code"]);

      console.log("profile_reducer. action: ", action);
      console.log("profile_reducer. returning props: ", returnProps);
      return returnProps;
    }
    // case UPDATE_USER_ATTR: {
    //   const returnProps = { ...state, message: { type: "info", content: action.payload } };
    //
    //   console.log("profile_reducer. action: ", action);
    //   console.log("profile_reducer. returning props: ", returnProps);
    //   return returnProps;
    // }
    // case REMOVE_MESSAGE: {
    //   const returnProps = { ...state, message: undefined };
    //
    //   console.log("profile_reducer. action: ", action);
    //   console.log("profile_reducer. returning props: ", returnProps);
    //   return returnProps;
    // }
    // case RESEND_SUBMIT_SMS_VERIFICATION_CODE: {
    //   const returnProps = { ...state, message: { type: action.payload.type, content: action.payload.message } };
    //
    //   console.log("profile_reducer. action: ", action);
    //   console.log("profile_reducer. returning props: ", returnProps);
    //   return returnProps;
    // }
    case FETCH_MY_CONTACTS: {
      const returnProps = { ...state, myUsers: action.payload.data, code: action.payload.code };
      return returnProps;
    }
    case REINVITE_USER: {
      return {
        ...state,
        reinviteUserApiResponse: action.payload.status
      };
    }
    case CHANGE_USER_ROLE:
      return {
        ...state,
        changeUserRoleApiResponse: action.payload.status
      };
    default:
      return state;
  }
}
